import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import TextField from '@mui/material/TextField';
import {
  FilterNone as CloneIcon,
  DoneAll as DoneIcon
} from '@mui/icons-material';
import ClickAwayListener from "@mui/material/ClickAwayListener";

const styles = theme => ({
  card: {
    display: 'flex',
    padding: 20,
    width: 250,
    position: 'absolute',
    right: 50,
    zIndex: 1000
  },
  input: {
    textAlign: 'center'
  },
  button: {
    color: theme.palette.primary.dark,
    marginLeft: theme.spacing(1)
  }
});

class Clone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      count: 1
    }
  }

  handleChange = evt => {
    this.setState({
      count: evt.target.value
    });
  };

  toggle = () => {
    this.setState(
      prevState => ({ editMode: !prevState.editMode})
    );
  };

  handleClone = () => {
    const {count} = this.state;
    if (count > 0) {
      this.props.onClone(count);
    }
    this.setState({ editMode: false });
  };

  closeResults = () => {
    this.setState({ editMode: false });
  };

  render() {
    const { editMode } = this.state;
    const { classes, placement } = this.props;
    return (
      <div>
        <Tooltip title="Clone" placement={placement}>
          <IconButton aria-label="Clone" onClick={this.toggle} size="large">
            <CloneIcon />
          </IconButton>
        </Tooltip>
        {editMode && (
          <ClickAwayListener onClickAway={this.closeResults}>
            <Card className={classes.card}>
              <TextField
                variant="standard"
                type="number"
                autoFocus
                label="# Of Clones"
                value={this.state.count}
                onChange={this.handleChange}
                inputProps={{
                  className: classes.input
                }} />
              <IconButton className={classes.button} onClick={this.handleClone} size="large">
                <DoneIcon />
              </IconButton>
            </Card>
          </ClickAwayListener>
        )}
      </div>
    );
  }
}

Clone.defaultProps = {
  placement: null
};

Clone.propTypes = {
  classes: PropTypes.object.isRequired,
  placement: PropTypes.string
};

export default withStyles(styles)(Clone);
